import {Component} from '@angular/core';
import {Router} from '@angular/router';
import {TokenStorageService} from './_services/token-storage.service';
import {LoginService} from '@irisims/justconsult-api';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent {
  title = 'ConsultOnline-front';
  loading = false;

  // token = <Token>{};

  constructor(
    private router: Router,
    private tokenStorageService: TokenStorageService,
    private loginService: LoginService) {
  }

  logout(): void {
    this.tokenStorageService.signOut();
    this.loginService.logout().subscribe(
      () => this.router.navigate(['/login']).then()
    );
  }
}
